import { render, staticRenderFns } from "./CalendarListItem.vue?vue&type=template&id=50906dc0&scoped=true"
import script from "./CalendarListItem.vue?vue&type=script&lang=ts"
export * from "./CalendarListItem.vue?vue&type=script&lang=ts"
import style0 from "./CalendarListItem.vue?vue&type=style&index=0&id=50906dc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50906dc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50906dc0')) {
      api.createRecord('50906dc0', component.options)
    } else {
      api.reload('50906dc0', component.options)
    }
    module.hot.accept("./CalendarListItem.vue?vue&type=template&id=50906dc0&scoped=true", function () {
      api.rerender('50906dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/CalendarListItem.vue"
export default component.exports